export default __webpack_public_path__ + "static/media/fp.b0ed5af8.png";